import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/api';

export const usePatientStats = (dateRange?: { start_date?: string; end_date?: string }) => {
  return useQuery({
    queryKey: ['patient-stats', dateRange],
    queryFn: () => analyticsApi.getPatientStats(dateRange),
  });
};